import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getItemSession } from "utils/session";
import { landingPageStrings } from "constants/constantStrings";

import BadgeLabel from "components/BadgeLabel";
import DupontIconButton from "components/DupontIconButton/index.js";
import Filter from "components/Filter";

import GridIcon from "assets/SvgIcon/GridIcon/Grid";
import ListIcon from "assets/SvgIcon/ListIcon/List";

import AlarmsCardsContainer from "./AlarmsCardsContainer.jsx";
import AlarmsTable from "./AlarmsTable.jsx";
import InsightCardsContainer from "./InsightCardContainer";
import SmartInsightTable from "./SmartInsightTable";
import SystemsCardsContainer from "./SystemsCardsContainer.jsx";
import SystemsTable from "./SystemsTable.jsx";


import "./SystemsAndAlarmsView.css";

const SystemsAndAlarmsView = ({ systems, history, activeAlarms, admin, anomalyData }) => {
  const [view, setView] = useState("cards");
  const [filterValue, setFilterValue] = useState("");
  const [selectedSystem, setselectedSystem] = useState([]);
  const [filterSystems, setFilterSystems] = useState(systems.length);
  const [filterAlarms, setfilterAlarms] = useState(activeAlarms.length);
  const [filterAnomaly, setFilterAnomaly] = useState(anomalyData.length);
  const [showTableFilterIcon, setShowTableFilterIcon] = useState(getItemSession("checkedStatus") !== null);
  const { isAdmin, isTier2 } = useSelector(state => state.user);

  useEffect(() => setselectedSystem(JSON.parse(getItemSession("filteredSystems")) ?? ""), []);
  const checkview = targetView => view && view.toLowerCase() === targetView;

  // const trustArcCookieURL = process.env.REACT_APP_TRUSTARC_CONSENT_URL;
  // if (trustArcCookieURL) {
  //   loadExternalScript(trustArcCookieURL);
  // }

  return (
    <div className="app-main-content-wrapper padding20">
      <div className="systemsNavbar">
        {/* \\{admin && */}
        <Filter
          setFilterValue={setFilterValue}
          selectedSystem={selectedSystem}
          setselectedSystem={setselectedSystem}
          setShowTableFilterIcon={setShowTableFilterIcon}
          showTableFilterIcon={showTableFilterIcon}
          customWidth="550px"
          placeholder={(isAdmin || isTier2) ? landingPageStrings.search:landingPageStrings.searchMessageTier1}
          landingPageView={view}
          showfilter
          customClass={"p-0"}
        />
        {/* } */}
        <div className="systemSelectOptions">
          <div className="linkUnderline systemSelectBtns" onClick={() => setView("cards")}>
            <DupontIconButton tooltip={landingPageStrings.gridView}>
              <GridIcon active={checkview("cards")} />
            </DupontIconButton>
          </div>
          <div className="linkUnderline systemSelectBtns" onClick={() => setView("table")}>
            <DupontIconButton tooltip={landingPageStrings.listView}>
              <ListIcon active={checkview("table")} />
            </DupontIconButton>
          </div>
        </div>
      </div>
      <div className="sysAlarmBody">
        {!checkview("map") && <BadgeLabel customClass="margin-top-20" badgeDescription={landingPageStrings.systems} badgeText={filterSystems} />}
        {checkview("cards") && (
          <SystemsCardsContainer
            systems={systems}
            filterValue={filterValue}
            selectedSystem={selectedSystem}
            setFilterSystems={setFilterSystems}
            activeAlarms={activeAlarms}
          />
        )}
        {checkview("table") && (
          <SystemsTable
            systems={systems}
            historyProps={history}
            filterValue={filterValue}
            selectedSystem={selectedSystem}
            setFilterSystems={setFilterSystems}
            showTableFilterIcon={showTableFilterIcon}
          />
        )}
        {(checkview("cards") || checkview("table")) && (isAdmin || isTier2) && (
          <BadgeLabel customClass="margin-top-20" badgeDescription={landingPageStrings.smartInsights} badgeText={filterAnomaly} />
        )}
        {checkview("cards") && anomalyData && (isAdmin || isTier2) && (
          <InsightCardsContainer
            insights={anomalyData}
            setFilterAnomaly={setFilterAnomaly}
            filterValue={filterValue}
            systems={systems}
            selectedSystem={selectedSystem}
          />
        )}
        {checkview("table") && (isAdmin || isTier2) &&(
          <SmartInsightTable
            historyProps={history}
            anomalyList={anomalyData}
            filterValue={filterValue}
            showTableFilterIcon={showTableFilterIcon}
            setFilterAnomaly={setFilterAnomaly}
          />
        )}
        {(checkview("cards") || checkview("table")) && (
          <BadgeLabel customClass="margin-top-20" badgeDescription={landingPageStrings.alarm} badgeText={filterAlarms} />
        )}
        {checkview("cards") && (
          <AlarmsCardsContainer
            activeAlarms={activeAlarms}
            filterValue={filterValue}
            setfilterAlarms={setfilterAlarms}
            systems={systems}
            selectedSystem={selectedSystem}
          />
        )}
        {checkview("table") && (
          <AlarmsTable
            historyProps={history}
            filterValue={filterValue}
            activeAlarms={activeAlarms}
            setfilterAlarms={setfilterAlarms}
            showTableFilterIcon={showTableFilterIcon}
          />
        )}
      </div>
    </div>
  );
};

export default SystemsAndAlarmsView;
